import React, { useEffect, useRef, useState, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import Modal from 'react-modal';
import Scrollbars from 'react-custom-scrollbars';
import { format } from 'date-fns';
import { Loader } from '../../../../components';
import {
  initiateSocketOperationalHistoric,
  getCommandConfiguration,
  getThingOperationByType,
} from '../../../../services';
import { notifyError } from '../../../../utils';
import ModalList from '../notification-modal/modal-list';
import ModalConfig from '../notification-modal/modal-config';
import * as s from './styled-notification';

const Notification = ({ thing }) => {
  const { colors } = useContext(ThemeContext);
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState();
  const [openModalConfig, setOpenModalConfig] = useState(false);
  const [configuracoes, setConfiguracoes] = useState([]);
  const [thingData, setThingData] = useState({});
  const [allNotifications, setAllNotifications] = useState([]);
  const [loadingScreen, setLoadingScreen] = useState(true);
  const [loadingNotification, setLoadingNotification] = useState(true);
  const [loadingModal, setLoadingModal] = useState(true);
  const [loadingScreenTimedOut, setLoadingScreenTimedOut] = useState(false);
  const timeoutIdRef = useRef(null);

  const filters = [
    { label: 'alarmes', value: 'ALARME' },
    { label: 'bloqueios', value: 'BLOQUEIO' },
    { label: 'trips', value: 'TRIP' },
  ];

  useEffect(() => {
    const socket = initiateSocketOperationalHistoric(thing.id, 'all');

    // Timeout de 20s: se o histórico não chegar, mostra estado de erro com
    // botão "Recarregar" em vez de loader infinito.
    timeoutIdRef.current = setTimeout(() => {
      setLoadingScreenTimedOut(true);
    }, 20000);

    getThingOperationByType(thing.id, 'all')
      .then((resp) => {
        setAllNotifications(resp.data);
      })
      .catch(() =>
        notifyError('Não foi possível buscar o histórico da thing')
      )
      .finally(() => {
        if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);
        setLoadingNotification(false);
        setLoadingScreen(false);
      });

    return () => {
      if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);
      socket.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatResp = (data, type) => {
    const tmp = [...data];
    tmp.map((t) => {
      return { ...t, type };
    });
    return tmp;
  };

  useEffect(() => {
    if (openModal) {
      if (!thingData[openModal]) {
        setLoadingModal(true);
        getCommandConfiguration(thing.id, openModal)
          .then(({ data }) => {
            setConfiguracoes(data);
          })
          .catch(() => notifyError('Erro ao buscar os comandos'));

        getThingOperationByType(thing.id, openModal)
          .then((resp) => {
            setThingData((t) => ({
              ...t,
              [openModal]: formatResp(resp.data, 'alarmes'),
            }));
          })
          .catch(() => {
            notifyError('Não foi possível buscar os alarmes da thing');
          })
          .finally(() => {
            setLoadingModal(false);
          });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal]);

  const labelByType = (type) => {
    if (type === 'alarm') return 'Alarme';
    if (type === 'blockade') return 'Bloqueio';
    if (type === 'trip') return 'Trips';
  };

  if (loadingScreen) {
    if (loadingScreenTimedOut) {
      return (
        <s.TimeoutContainer>
          <s.TimeoutTitle>Notificações indisponíveis</s.TimeoutTitle>
          <s.TimeoutMessage>
            O servidor não respondeu em 20 segundos. Verifique sua conexão ou
            tente recarregar a página.
          </s.TimeoutMessage>
          <s.RetryButton
            type="button"
            onClick={() => window.location.reload()}
          >
            Recarregar
          </s.RetryButton>
        </s.TimeoutContainer>
      );
    }
    return <Loader />;
  }

  return (
    <s.Container open={open}>
      <>
        <Modal
          isOpen={!!openModal}
          style={s.getModalStyles(colors)}
          appElement={document.getElementById('root')}
        >
          <ModalList
            loadingModal={loadingModal}
            openModal={openModal}
            setOpenModal={setOpenModal}
            thingData={thingData}
            setOpenModalConfig={setOpenModalConfig}
            openModalConfig={openModalConfig}
            setConfiguracoes={setConfiguracoes}
          />
        </Modal>
        {openModalConfig && (
          <Modal
            isOpen={openModalConfig}
            style={s.getModalStylesConfig(colors)}
            appElement={document.getElementById('root')}
          >
            <ModalConfig
              thingId={thing.id}
              openModal={openModal}
              configuracoes={configuracoes}
              setOpenModalConfig={setOpenModalConfig}
              setConfiguracoes={setConfiguracoes}
            />
          </Modal>
        )}

        <div id="notification-box">
          <s.TotalWrapper>
            <div id="total">{allNotifications.length}</div>
            <div id="status">
              <s.Label bold color={colors.darkerblue}>
                NOTIFICACÕES
              </s.Label>
              <s.Label color={colors.label} size="12px">
                status
              </s.Label>
            </div>
          </s.TotalWrapper>

          <s.FilterWrapper open={open}>
            {filters.map((opt) => (
              <button
                key={opt.label}
                type="button"
                id="option"
                onClick={() => setOpenModal(opt.value)}
              >
                {opt.label}
              </button>
            ))}
          </s.FilterWrapper>
        </div>

        <div id="notification-box-second">
          {open ? (
            <Scrollbars
              renderThumbHorizontal={() => <div style={{ display: 'none' }} />}
            >
              {allNotifications.length > 0 ? (
                allNotifications.map((notifi) => (
                  <s.Notification>
                    <label id="status">
                      {labelByType(
                        notifi.variableRelation &&
                          notifi.variableRelation.type &&
                          notifi.variableRelation.type.name
                      )}
                    </label>
                    <label id="data">
                      {notifi.variableRelation && (
                        <>
                          &nbsp;|
                          {format(
                            new Date(notifi.insertdate),
                            'dd.MM.yyyy - HH:mm'
                          )}
                          | &nbsp;
                        </>
                      )}
                    </label>
                    <label id="description">
                      {notifi.variableRelation && notifi.variableRelation.name}
                    </label>
                  </s.Notification>
                ))
              ) : loadingNotification ? (
                <Loader />
              ) : (
                <s.Label bold color={colors.label}>
                  Não há notificações
                </s.Label>
              )}
            </Scrollbars>
          ) : (
            <s.Notification clickable>
              <label id="status">
                {allNotifications.length > 0 &&
                allNotifications[0].variableRelation
                  ? labelByType(allNotifications[0].variableRelation.type.name)
                  : '-----'}
              </label>
              <label id="data">
                |
                {allNotifications.length > 0
                  ? format(
                      new Date(allNotifications[0].insertdate),
                      'dd.MM.yyyy - HH:mm'
                    )
                  : '-----'}
                |
              </label>
              <label id="description">
                {allNotifications.length > 0 &&
                allNotifications[0].variableRelation
                  ? allNotifications[0].variableRelation.name
                  : '-----'}
              </label>
            </s.Notification>
          )}

          <s.Button open={open} onClick={() => setOpen(!open)}>
            Ver {open ? 'menos' : 'mais'}
          </s.Button>
        </div>
      </>
    </s.Container>
  );
};

export default Notification;
